import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { finalize } from 'rxjs';
import { sha256 } from 'js-sha256';

@Component({
    selector     : 'auth-forgot-password',
    templateUrl  : './forgot-password.component.html',
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations,
    standalone   : true,
    imports      : [NgIf, FuseAlertComponent, FormsModule, MatIconModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatProgressSpinnerModule, RouterLink],
})
export class AuthForgotPasswordComponent implements OnInit
{
    @ViewChild('forgotPasswordNgForm') forgotPasswordNgForm: NgForm;

    public alert: { type: FuseAlertType; message: string } = {
        type   : 'success',
        message: '',
    };
    public forgotPasswordForm: UntypedFormGroup;
    public showAlert: boolean = false;
    public logo: string;
    public emailHash: string;

    private referrer: string;

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder,
        private _strapiService: StrapiService,
        private _gtmService: GtmService,
        private router: Router,

        @Inject(PLATFORM_ID) private platformId: any
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        if (isPlatformBrowser(this.platformId)) {

            if(localStorage.getItem('currentURL')) {
              if(localStorage.getItem('currentURL') == window.location.href) {
                //this.referrer = window.location.href
              } else {
                this.referrer = localStorage.getItem('currentURL')
                localStorage.setItem('currentURL', window.location.href);
                localStorage.setItem('previousURL', this.referrer);
              }
            } else {
              localStorage.setItem('currentURL', window.location.href);
            }
      
              const route = window.location.href;
              const path = this.router.url;

              this._gtmService.forgotPasswordPageReferrer = route;
      
              this._gtmService.pushEvent({ 
                event: 'page_view',
                page_url: route,
                page_path: path,
                page_title: 'forgot_password_page',
                page_referrer: this.referrer ? this.referrer : route
              });
            }
            

         // get content from Strapi
         this._strapiService.getAuthScreenContent()
         .subscribe({
             next: (res: any) => {
                 this.logo = res.data.logo.url;
             }
         });

        // Create the form
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Send the reset link
     */
    sendResetLink(): void
    {
        // Return if the form is invalid
        if ( this.forgotPasswordForm?.invalid )
        {
            return;
        }

        // Disable the form
        this.forgotPasswordForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Forgot password
        this._authService.forgotPassword(this.forgotPasswordForm.get('email').value).subscribe({
            next:()=>{

                if (isPlatformBrowser(this.platformId)) {

                    let emailHash = '';

                    emailHash = sha256(this.forgotPasswordForm.get('email').value);
                    localStorage.setItem('emailHash', emailHash);


                    const route = this._gtmService.forgotPasswordPageReferrer;
                    const path = this.router.url;
                    
                    this._gtmService.pushEvent({ 
                      event: 'forgot_password', 
                      page_url: route, 
                      page_path: path, 
                      page_title: 'forgot_password_page',
                      page_referrer: route, 
                      email: emailHash
                    });
                }


                // store email locally
                localStorage.setItem('email', this.forgotPasswordForm.get('email').value);
                this.forgotPasswordForm.enable();
                this.forgotPasswordNgForm.resetForm();
              
                // Set the alert
                this.alert = {
                    type   : 'success',
                    message: 'Password reset request submitted! If you\'re registered on our system, you\'ll receive an email shortly.',
                };
                this.showAlert = true;
            
            },
            error:()=>{
                this.forgotPasswordForm.enable();
                this.forgotPasswordNgForm.resetForm();
                this.alert = {
                    type   : 'error',
                    message: 'Email does not found! Are you sure you are already a member?',
                };
                this.showAlert = true;
            }
        });
    }
}
